import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWithInventoryAts = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "As a list" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "24x24px---NoNo-Def-No-Frame-&-Header-Color",
			transform: "translate(-735.000000, -68.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Portrait",
				transform: "translate(53.000000, 68.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "As-a-list",
					transform: "translate(682.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Frame-for-Icon",
						x: 0,
						y: 0,
						width: 24,
						height: 24
					}), /* @__PURE__ */ _jsxs("g", {
						id: 1,
						transform: "translate(1.000000, 1.000000)",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-4",
								transform: "translate(0.000000, 8.000000)",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy-7",
										fill: "#AFBCC5",
										x: 7,
										y: 10,
										width: 15,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy-6",
										fill: "#AFBCC5",
										x: 7,
										y: 8,
										width: 7.5,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy",
										fill: "#8C9BA8",
										x: 0,
										y: 0,
										width: 6,
										height: 6,
										rx: .15
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-3",
								transform: "translate(0.000000, 8.000000)",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy-5",
										fill: "#AFBCC5",
										x: 7,
										y: 2,
										width: 15,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy-4",
										fill: "#AFBCC5",
										x: 7,
										y: 0,
										width: 7.5,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle-Copy-3",
										fill: "#8C9BA8",
										x: 0,
										y: 8,
										width: 6,
										height: 6,
										rx: .15
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group",
								children: [
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										fill: "#AFBCC5",
										x: 7,
										y: 2,
										width: 15,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										fill: "#AFBCC5",
										x: 7,
										y: 0,
										width: 7.5,
										height: 1,
										rx: .15
									}),
									/* @__PURE__ */ _jsx("rect", {
										id: "Rectangle",
										fill: "#8C9BA8",
										x: 0,
										y: 0,
										width: 6,
										height: 6,
										rx: .15
									})
								]
							})
						]
					})]
				})
			})
		})
	})]
});
export { SvgWithInventoryAts as ReactComponent };
